import React, {
    useCallback, useEffect, useState, useMemo
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalNextProvider, Loader, FormattedDate } from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { useAuthentication } from 'gw-digital-auth-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { error } from '@jutro/logger';
import { PolicyService } from 'gw-capability-policy';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import _ from 'lodash';
import metadata from './RiskManagement.metadata.json5';
import styles from '../RiskManagement.module.scss';
import '../RiskManagement.messages';

function RiskManagement({ history }) {
    const auth = useAuthentication();
    const [riskManagementCourses, updateRiskManagementCourses] = useState([]);
    const [isLoading, updateLoading] = useState(true);

    useEffect(() => {
        PolicyService.getRiskMgmtForProfessionalLiability(auth.authHeader)
            .then((data) => {
                const sortedData = _.orderBy(data, [(obj) => new Date(obj.startDate)], ['desc']);
                return updateRiskManagementCourses(sortedData);
            })
            .catch((err) => {
                error(`Unable to update RiskManagement courses ${JSON.stringify(err)}`);
                ModalNextProvider.showAlert({
                    title: commonMessages.genericError,
                    message: commonMessages.genericErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).then(() => {
                    history.push('/error');
                }, _.noop);
            })
            .finally(() => {
                updateLoading(false);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const seminarURL = useMemo(() => {
        return _.get(appConfig, `tdic.portalSeminarURL.${_.toLower(process.env.NODE_ENV)}`, _.get(appConfig, 'tdic.portalSeminarURL.development'));
    },
    []);

    const toolsURL = useMemo(() => {
        return _.get(appConfig, `tdic.portalToolsURL.${_.toLower(process.env.NODE_ENV)}`, _.get(appConfig, 'tdic.portalToolsURL.development'));
    },
    []);

    const getCell = useCallback((items, index, property) => {
        return items[property.id];
    }, []);

    const getFormattedDate = useCallback((items, index, { path: property }) => {
        if (typeof items[property] === 'undefined') {
            return '';
        }
        return <FormattedDate value={new Date(items[property])} format="short" />;
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrideProps = {
        riskManagementSeminarInfoLink: {
            href: seminarURL
        },
        riskManagementToolsInfoLink: {
            href: toolsURL
        },
        riskManagementTable: {
            data: riskManagementCourses
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell,
            getFormattedDate
        }
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

RiskManagement.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(RiskManagement);
